import { IAggFunc } from "@ag-grid-community/core";
import { GenericTableCell } from "gen/model/genericTableCell";
import { GenericTableRow } from "gen/model/genericTableRow";
import {
  getDataTableAgHeaderComponentParams,
  moneyCellValue,
} from "shared/components/table/data/DataTableUtils";
import { sumDecimalStrings } from "shared/utils/DecimalUtils";

export const aggFuncForFeesBreakdown: IAggFunc<
  GenericTableRow,
  GenericTableCell
> = (params) => {
  // this aggregation function is used for the rate columns in the fee charge event breakdown and fee catch up breakdown

  if (params.colDef.colId?.startsWith("rate_")) {
    const indexName = params.colDef.colId.substring("rate_".length);
    const basisColId = `basis_${indexName}`;
    const amountColId = `amount_${indexName}`;

    // NOTE: Not using params.rowNode.aggData here because
    // there's no guarantee that the basis and amount columns
    // will be computed before this column, so we need to
    // aggregate ourselves.

    const basisTotal = sumDecimalStrings(
      params.rowNode.allLeafChildren.map(
        (it) => moneyCellValue(it.data?.cells[basisColId]) || "0",
      ),
    );
    const amountTotal = sumDecimalStrings(
      params.rowNode.allLeafChildren.map(
        (it) => moneyCellValue(it.data?.cells[amountColId]) || "0",
      ),
    );

    const { column, parentColumns } = getDataTableAgHeaderComponentParams(
      params.column,
    );

    const columnWithFeeBreakdownMetadata = [
      ...(parentColumns ?? []),
      column,
    ].find((it) => it.metadata?.type === "fee_breakdown");

    const dayFactor =
      columnWithFeeBreakdownMetadata?.metadata?.type === "fee_breakdown"
        ? columnWithFeeBreakdownMetadata.metadata.days_factor!
        : "1";

    return {
      value: {
        type: "percent",
        value: amountTotal.div(basisTotal).div(dayFactor).mul(100).toString(),
      },
    };
  }
};
